export default "__VITE_ASSET__ViIPXOid__"